import { useSyncExternalStore } from 'react';

// Module-level store so Sandy's conversation survives page navigation (the
// chat component remounts on every route change). One conversation per key
// (surface + signed-in user + class, audit F2 2026-10-19; the admin surface
// adds the school id), kept in a
// small bounded Map so switching surface/school and back does not destroy the
// earlier conversation. Deliberately not persisted: a fresh tab is a fresh chat.
const store = new Map();

// One id per conversation (ClaudeSandyConversations row; the tutor accepts
// [A-Za-z0-9_-]{1,64}). Every Buffy surface uses this one maker.
export const newConvoId = () => window.crypto?.randomUUID?.() || `c${Date.now()}${Math.random().toString(36).slice(2, 10)}`;

// What a chat shows (W4-B, 2026-10-20): the bubbles and whether a reply is on
// its way live here, not in the component, so a reply still arriving after a
// page change lands in this chat and the panel on the new page shows it.
const snapOf = (chat) => ({ messages: chat.messages, busy: chat.busy, thinking: chat.thinking, toolStatus: chat.toolStatus });

export function getSandyChat(key, intro) {
  if (!store.has(key)) {
    if (store.size >= 8) store.delete(store.keys().next().value);
    const chat = {
      key,
      // convoId keys this conversation's row in ClaudeSandyConversations
      // (the lambda logs full transcripts, 2026-08-19).
      convoId: newConvoId(),
      // intro: true marks the page's opening line, which is not a conversation.
      messages: intro ? [{ role: 'ai', text: intro, intro: true }] : [],
      convo: [],
      lastSeed: null,
      // busy: a reply is on its way (one at a time per chat); controller
      // cancels it. thinking / toolStatus: the waiting line under the chat.
      busy: false,
      thinking: false,
      toolStatus: null,
      controller: null,
      listeners: new Set(),
    };
    chat.snap = snapOf(chat);
    store.set(key, chat);
  }
  return store.get(key);
}

// patch: fields to change, or a function of the chat that returns them.
export function setSandyChat(chat, patch) {
  Object.assign(chat, typeof patch === 'function' ? patch(chat) : patch);
  chat.snap = snapOf(chat);
  chat.listeners.forEach((fn) => fn());
}

export function useSandyChat(chat) {
  return useSyncExternalStore(
    (fn) => { chat.listeners.add(fn); return () => chat.listeners.delete(fn); },
    () => chat.snap,
  );
}
